<template>
  <div class="report">
    <el-row :gutter="10">
      <el-col :span="24">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>Home</el-breadcrumb-item>
          <el-breadcrumb-item>Commission Report</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="24">
        <div class="report-title">Commission Report</div>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="24">
        <label class="report-item-title">佣金汇总(所有)</label>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="4">
        <label for="">ProjectType</label>
        <el-select v-model="searchfilter.ProjectType" placeholder="">
          <el-option
            v-for="item in projecttype_op"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="12">
        <el-input v-model="searchfilter.Keyword" placeholder="Keyword Search"></el-input>
      </el-col>
      <el-col :span="6">
        <el-button type="primary" @click="Search">Search</el-button>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="24">
        <el-scrollbar
          style="height: calc(100vh - 60px - 40px - 29px - 36px - 46px - 47px - 15px)"
        >
          <el-table :data="summary.data" style="width: 100%" border>
            <el-table-column prop="item_id" label="item_id" width="110"></el-table-column>
            <el-table-column prop="item_LogYear" label="">
              <template #header>
                <div>版本<br />Year</div>
              </template>
            </el-table-column>
            <el-table-column prop="item_LogName" label="" width="95">
              <template #header>
                <div>版本<br />LogName</div>
              </template>
            </el-table-column>
            <el-table-column prop="projectType" label="ProjectType"> </el-table-column>
            <el-table-column
              prop="commissionSalesman"
              label="CommissionSalesman"
              width="110"
            >
            </el-table-column>
            <el-table-column prop="logYear" label="">
              <template #header>
                <div>銷售<br />Year</div>
              </template>
            </el-table-column>
            <el-table-column prop="logName" label="" width="95">
              <template #header>
                <div>銷售<br />LogName</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="max"
              label="Max"
              width="105"
              align="right"
              :formatter="getformatter_money"
            >
            </el-table-column>
            <el-table-column
              prop="hold"
              label="Hold"
              width="105"
              align="right"
              :formatter="getformatter_money"
            >
            </el-table-column>
            <el-table-column
              prop="release"
              label="Release"
              width="105"
              align="right"
              :formatter="getformatter_money"
            >
            </el-table-column>
            <el-table-column
              prop="individualCommission_Max"
              label=""
              width="115"
              align="right"
              :formatter="getformatter_money"
            >
              <template #header>
                <div>
                  Individual<br />
                  Commission<br />- Max
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="individualCommission_Hold"
              label=""
              width="115"
              align="right"
              :formatter="getformatter_money"
            >
              <template #header>
                <div>
                  Individual<br />
                  Commission<br />- Hold
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="individualCommission_Release"
              label=""
              width="115"
              align="right"
              :formatter="getformatter_money"
            >
              <template #header>
                <div>
                  Individual<br />
                  Commission<br />- Release
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="teamCommission_Max"
              label=""
              width="115"
              align="right"
              :formatter="getformatter_money"
            >
              <template #header>
                <div>
                  Team<br />
                  Commission<br />- Max
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="teamCommission_Hold"
              label=""
              width="115"
              align="right"
              :formatter="getformatter_money"
            >
              <template #header>
                <div>
                  Team<br />
                  Commission<br />- Hold
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="teamCommission_Release"
              label=""
              width="115"
              align="right"
              :formatter="getformatter_money"
            >
              <template #header>
                <div>
                  Team<br />
                  Commission<br />- Release
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="salesHeadCommission_Max"
              label=""
              width="115"
              align="right"
              :formatter="getformatter_money"
            >
              <template #header>
                <div>
                  SalesHead<br />
                  Commission<br />- Max
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="salesHeadCommission_Hold"
              label=""
              width="115"
              align="right"
              :formatter="getformatter_money"
            >
              <template #header>
                <div>
                  SalesHead<br />
                  Commission<br />- Hold
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="salesHeadCommission_Release"
              label=""
              width="115"
              align="right"
              :formatter="getformatter_money"
            >
              <template #header>
                <div>
                  SalesHead<br />
                  Commission<br />- Release
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="productionIndividual_Max"
              label=""
              width="115"
              align="right"
              :formatter="getformatter_money"
            >
              <template #header>
                <div>Production <br />- Individual <br />- Max</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="productionIndividual_Hold"
              label="Production - Individual - Hold"
              width="115"
              align="right"
              :formatter="getformatter_money"
            >
              <template #header>
                <div>Production <br />- Individual <br />- Hold</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="productionIndividual_Release"
              label="Production - Individual - Release"
              width="115"
              align="right"
              :formatter="getformatter_money"
            >
              <template #header>
                <div>Production <br />- Individual <br />- Release</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="totalamounttobereleased"
              label="Total amount to be released"
              width="105"
              align="right"
              :formatter="getformatter_money"
            >
            </el-table-column>
            <el-table-column
              prop="alreadyreleased"
              label="Already released"
              width="105"
              align="right"
              :formatter="getformatter_money"
            >
            </el-table-column>
            <el-table-column
              prop="actualamounttobereleased"
              label="Actual amount to be released"
              width="105"
              align="right"
              :formatter="getformatter_money"
            >
            </el-table-column>
            <el-table-column
              prop="paid1"
              label="2021 Paid Log1"
              width="100"
              align="right"
              :formatter="getformatter_money"
            >
            </el-table-column>
            <el-table-column
              prop="paid2"
              label="2021 Paid Log2"
              width="100"
              align="right"
              :formatter="getformatter_money"
            >
            </el-table-column>
            <el-table-column
              prop="paid3"
              label="2021 Paid Log3"
              width="100"
              align="right"
              :formatter="getformatter_money"
            >
            </el-table-column>
            <el-table-column
              prop="paid4"
              label="2021 Paid Log4"
              width="100"
              align="right"
              :formatter="getformatter_money"
            >
            </el-table-column>
            <el-table-column
              prop="paid5"
              label="2021 Paid Log5"
              width="100"
              align="right"
              :formatter="getformatter_money"
            >
            </el-table-column>
            <el-table-column
              prop="paid6"
              label="2021 Paid Log6"
              width="100"
              align="right"
              :formatter="getformatter_money"
            >
            </el-table-column>
            <el-table-column
              prop="paid7"
              label="2021 Paid Log7"
              width="100"
              align="right"
              :formatter="getformatter_money"
            >
            </el-table-column>
            <el-table-column
              prop="paid8"
              label="2021 Paid Log8"
              width="100"
              align="right"
              :formatter="getformatter_money"
            >
            </el-table-column>
            <el-table-column
              prop="paid9"
              label="2021 Paid Log9"
              width="100"
              align="right"
              :formatter="getformatter_money"
            >
            </el-table-column>
            <el-table-column
              prop="paid10"
              label="2021 Paid Log10"
              width="100"
              align="right"
              :formatter="getformatter_money"
            >
            </el-table-column>
            <el-table-column
              prop="paid11"
              label="2021 Paid Log11"
              width="100"
              align="right"
              :formatter="getformatter_money"
            >
            </el-table-column>
            <el-table-column
              prop="paid12"
              label="2021 Paid Log12"
              width="100"
              align="right"
              :formatter="getformatter_money"
            >
            </el-table-column>
            <el-table-column
              prop="paid13"
              label="2021 Paid Log13"
              width="100"
              align="right"
              :formatter="getformatter_money"
            ></el-table-column>
            <el-table-column
              prop="paid14"
              label="2021 Paid Log14"
              width="100"
              align="right"
              :formatter="getformatter_money"
            >
            </el-table-column>
            <el-table-column
              prop="total_DIFF"
              label="Total DIFF"
              width="100"
              align="right"
              :formatter="getformatter_money"
            >
            </el-table-column>
            <el-table-column
              prop="final_Release"
              label="Final Release"
              width="120"
              align="right"
              :formatter="getformatter_money"
            >
            </el-table-column>
            <el-table-column
              prop="total_Release"
              label="Total Release"
              width="120"
              align="right"
              :formatter="getformatter_money"
            >
            </el-table-column>
          </el-table>
        </el-scrollbar>
      </el-col>
    </el-row>
  </div>
</template>

<script setup>
import { reactive, onMounted } from "vue";
import { formatter_money } from "@/assets/js/formatter.js";
import { commissionsummarys } from "@/network/commission.js";
const projecttype_op = reactive([
  {
    value: "BUS",
    label: "BUS",
  },
]);

const searchfilter = reactive({
  ProjectType: "BUS",
  Keyword: "",
});

//const summaryjson = require("./json/commission_summary_all.json");

let summary = reactive({
  data: [],
});

// 转换会计格式
const getformatter_money = (row, column, cellValue) => {
  return formatter_money(cellValue, "", "");
};

onMounted(async () => {
  Search();
});

const Search = async () => {
  console.log("searchfilter.Keyword", searchfilter.Keyword);
  const summarylist = await commissionsummarys(searchfilter.Keyword).then(
    (res) => res.data
  );

  summary.data = summarylist;
};
</script>

<style scoped>
.report-title {
  font-size: 1.1rem;
  text-align: center;
}
.report-item-title {
  font-size: 1.5rem;
}
</style>
